// utils/routerWithChain.ts
import useWallet from 'rfx/lib/wallets/useWallet'
import { useRouter } from 'next/router'

export function useRouterWithChain() {
  const { chainId } = useWallet()
  const router = useRouter()

  const push = (url: any) => {
    url.query.chainId = chainId
    router.push(url)
  }

  return { push }
}
